function ByEthnicityPrimaryList(_isOmit) {
    var by = $("input:radio[class=EthnicityPrimaryListBy]:checked").val();

    $("#EthnicityPrimaryItemListContent").html('<img alt="Refreshing..." src="/Images/Common/LoadingGreenMed.gif" class="AccordionPaneLoadingImage">');

    $.DotComAjax({
        url: "/CanadianConsumer/EthnicityPrimaryListAjax?isOmit=" + _isOmit + "&byCountry=" + by,
        cache: false,
//        async: true,
        success: function (data) {
            $("#EthnicityPrimaryItemListContent").html(data);
            InitializeEthnicityPrimaryList();
            if (typeof success == 'function') {
                success();
            }
        },
        error: function () {
            $("#EthnicityPrimaryItemListContent").html('<div style="padding-left: 30px;"><font color="red">There was an error retrieving the ethnicities list</font></div>');
        },
        async: true
    });
}

function InitializeEthnicityPrimaryList() {

    $('.lvl1-eth-prim input:checkbox', '#EthnicityPrimaryItemListContent').click(function (e) {
        var currentItem = $(this).closest('.eth-prim-parent');
        if ($(this).is(':checked')) {
            currentItem.find('input:checkbox').prop('checked', true);
        } else {
            currentItem.find('input:checkbox').prop('checked', false);
        }

        UpdateSelectedEthnicityPrimaryItems();
    });

    $('.lvl2-eth-prim input:checkbox', '#EthnicityPrimaryItemListContent').click(function () {

        $(this).closest('.eth-prim-child').find('input:checkbox').prop('checked', $(this).is(':checked'));

        var currentItem = $(this).closest('.eth-prim-parent');
        var secondLevel = currentItem.find('.lvl2-eth-prim');
        var secondLevelChk = secondLevel.find('input:checkbox');
        var secondLevelChkSelected = secondLevel.find('input:checkbox:checked');

        if (secondLevelChk.length === secondLevelChkSelected.length) {
            currentItem.find('.lvl1-eth-prim input:checkbox').prop('checked', true);
        } else {
            currentItem.find('.lvl1-eth-prim input:checkbox').prop('checked', false);
        }
        var firstLevelId = currentItem.find('.lvl1-eth-prim input:checkbox').attr('id');
        UpdateSelectedEthnicityPrimaryItems();
    });

    $('.lvl3-eth-prim input:checkbox', '#EthnicityPrimaryItemListContent').click(function () {

        $(this).closest('.eth-prim-grand-child').find('input:checkbox').prop('checked', $(this).is(':checked'));

        var currentItem = $(this).closest('.eth-prim-parent');
        var thirdLevel = $(this).closest('.lvl3-eth-prim-tree');
        var thirdLevelChk = thirdLevel.find('input:checkbox');
        var thirdLevelChkSelected = thirdLevel.find('input:checkbox:checked');

        var secondLevelSingleChk = $(this).closest('.eth-prim-child').find('.lvl2-eth-prim input:checkbox')
        if (thirdLevelChk.length === thirdLevelChkSelected.length) {
            secondLevelSingleChk.prop('checked', true);
        } else {
            secondLevelSingleChk.prop('checked', false);
        }

        var secondLevel = currentItem.find('.lvl2-eth-prim');
        var secondLevelChk = secondLevel.find('input:checkbox');
        var secondLevelChkSelected = secondLevel.find('input:checkbox:checked');

        if (secondLevelChk.length === secondLevelChkSelected.length) {
            currentItem.find('.lvl1-eth-prim input:checkbox').prop('checked', true);
        } else {
            currentItem.find('.lvl1-eth-prim input:checkbox').prop('checked', false);
        }
        var firstLevelId = currentItem.find('.lvl1-eth-prim input:checkbox').attr('id');
        UpdateSelectedEthnicityPrimaryItems();
    });

    $('.lvl4-eth-prim input:checkbox', '#EthnicityPrimaryItemListContent').click(function () {
        var currentItem = $(this).closest('.eth-prim-parent');

        var fourthLevel = $(this).closest('.lvl4-eth-prim-tree');
        var fourthLevelChk = fourthLevel.find('input:checkbox');
        var fourthLevelChkSelected = fourthLevel.find('input:checkbox:checked');

        if (fourthLevelChk.length === fourthLevelChkSelected.length) {
            $(this).closest('.eth-prim-grand-child').find('.lvl3-eth-prim input:checkbox').prop('checked', true);
        } else {
            $(this).closest('.eth-prim-grand-child').find('.lvl3-eth-prim input:checkbox').prop('checked', false);
        }

        var thirdLevel = $(this).closest('.lvl3-eth-prim-tree');
        var thirdLevelChk = thirdLevel.find('input:checkbox');
        var thirdLevelChkSelected = thirdLevel.find('input:checkbox:checked');

        var secondLevelSingleChk = $(this).closest('.eth-prim-child').find('.lvl2-eth-prim input:checkbox');
        if (thirdLevelChk.length === thirdLevelChkSelected.length) {
            secondLevelSingleChk.prop('checked', true);
        } else {
            secondLevelSingleChk.prop('checked', false);
        }

        var secondLevel = currentItem.find('.lvl2-eth-prim');
        var secondLevelChk = secondLevel.find('input:checkbox');
        var secondLevelChkSelected = secondLevel.find('input:checkbox:checked');

        if (secondLevelChk.length === secondLevelChkSelected.length) {
            currentItem.find('.lvl1-eth-prim input:checkbox').prop('checked', true);
        } else {
            currentItem.find('.lvl1-eth-prim input:checkbox').prop('checked', false);
        }
        var firstLevelId = currentItem.find('.lvl1-eth-prim input:checkbox').attr('id');
        UpdateSelectedEthnicityPrimaryItems();
    });

    UpdateSelectedEthnicityPrimaryItems();
}

function UpdateSelectedEthnicityPrimaryItems() {
    $('#SelectedEthnicityPrimaryItems').val("");

    $('.eth-prim-checkbox', '#EthnicityPrimaryItemListContent').each(function (index, item) {
        var chk = $(item).find('input:checkbox');
        var chkSelected = $(item).find('input:checkbox:checked');
        if (chkSelected.length > 0) {
            var chkId = chk.attr('id');
            if (chkId != $("#DescriptionP" + chkId).html().toUpperCase().replace(' ', '_')) {
                var selection = "~" + chkId + ":" + $("#DescriptionP" + chkId).html();
                $('#SelectedEthnicityPrimaryItems').val($('#SelectedEthnicityPrimaryItems').val() + selection);
            }
        }
    });
}

function HideShowEthnicityPrimaryChildren(evt) {
    var key = evt.id;
    key = key.replace("imgP", "");

    if ($('#HeaderP' + key + ' input:checkbox:first').is(":checked")) {
        $('#EthnicityPrimaryChildren' + key + ' input:checkbox').prop('checked', $('#HeaderP' + key + " input:checkbox").prop('checked'));
    }

    if ($('#imgP' + key).attr('src') == '/Images/Common/plus_new.gif') {
        $('#imgP' + key).attr('src', '/Images/Common/minus_new.gif');
        $('#EthnicityPrimaryChildren' + key).show();

    }
    else {
        $('#imgP' + key).attr('src', '/Images/Common/plus_new.gif');
        $('#EthnicityPrimaryChildren' + key).hide();
    }
}
